import { colors } from '@material-ui/core';

import AmazonLogo from 'src/assets/amazon_logo_light.svg';
import AmazonIcon from 'src/assets/amazon_icon.png';
import AmazonCoverPageLogo from 'src/assets/amazon_logo_dark.svg';

const amazonBrandConfig = {
  urls: ['amazon-staging-us.prosaris.ca', 'amazon-rme-staging.prosaris.ca', 'amazon-rme.prosaris.ca'],
  theme: {
    PRIMARY_COLOR: '#00759D',
    PRIMARY_DARK: '#006385',
    SECONDARY_COLOR: '#242F3E',
    PRIMARY_TEXT: '#323E48',
    ACCENT_TEXT: '#fff',
    DARK_BACKGROUND: '#242F3E',
    SUCCESS: '#0D7B3B',
    WARNING: '#B29600',
    ERROR: '#BD1717',
    BRANDING_MAIN: '#323E48',
    BRANDING_SHADE: '#323E48',
    MAIN_LAYOUT: {
      BACKGROUND: '#323E48',
      PRIMARY_COLOR: '#00A7E1',
      PRIMARY_DARK: '#00759D',
      SECONDARY_COLOR: '#00A7E1',
      ACCENT_COLOR: '#00759D',
      TEXT_PRIMARY: '#333740',
      TEXT_SECONDARY: '#333740',
      INPUT_BACKGROUND: '#ffffff',
      INPUT_BORDER: '#333740',
      BUTTON_BACKGROUND: '#323E48',
      BUTTON_COLOR: '#ffffff',
      BUTTON_HOVER: '#242F3E',
    },
    UNIT_TOGGLE_BUTTON: {
      ACTIVE: {
        BACKGROUND: '#00759D',
        COLOR: '#ffffff',
        HOVER: {
          BACKGROUND: '#006385',
          COLOR: '#ffffff',
        },
      },
      INACTIVE: {
        BACKGROUND: '#ffffff',
        COLOR: '#006385',
        HOVER: {
          BACKGROUND: colors.grey[100],
          COLOR: '#006385',
        },
      },
    },
    TOPBAR: {
      ACTIVE: {
        BACKGROUND: '#00759D',
        COLOR: '#ffffff',
      },
      INACTIVE: {
        BACKGROUND: '#323E48',
        COLOR: '#ffffff',
      },
      TEXT: '#ffffff',
    },
  },
  logo: {
    login: {
      src: AmazonLogo,
      height: 60,
      alt: 'Amazon RME Logo',
    },
    topbar: {
      src: AmazonLogo,
      height: 30,
      alt: 'Amazon RME Logo',
    },
    report: {
      src: AmazonCoverPageLogo,
      height: 25,
      alt: 'Amazon RME Logo',
    },
    coverPage: {
      src: AmazonCoverPageLogo,
      height: 40,
      alt: 'Amazon RME Logo',
    },
    favicon: {
      src: AmazonIcon,
    },
  },
  title: 'Amazon RME PROSARIS Platform',
  bannersEnabled: false,
  poweredByEnabled: true,
  ol1Enabled: false,
  overrideExistingRegistration: true,
  viewOnboardingProgress: true,
  companyInfo: {
    name: 'Amazon RME PROSARIS',
    email: 'support@prosaris.ca',
  },
};

export default amazonBrandConfig;
